export default "__VITE_ASSET__CjncxTdw__"